import styled from '@emotion/styled';
import { Magnetic as Mi } from '@mitchell/react.component.ux';
export const StyledRepairContent = styled('div') `
	text-align: justify;
	padding: 0 ${Mi.spacer24} ${Mi.spacer12} ${Mi.spacer24};
`;
export const StyledShopAddress = styled('div') `
	margin-bottom: ${Mi.spacer04};
`;
export const StyledDescription = styled('p') `
	margin: 0;
`;
export const StyledInnerDescription = styled('p') `
	margin-bottom: 0;
`;
export const StyledDivAvatarSpechBoxLayout = styled('div')(`
	padding: ${Mi.spacer24} 0px;
`);
//# sourceMappingURL=RepairSelectShopComponent.style.js.map